(() => {
  const controllers = new WeakMap();
  const query = '(min-width: 990px) and (hover: hover) and (pointer: fine)';

  class HeaderHover {
    constructor(menu) {
      this.menu = menu;
      this.details = menu.querySelector('details');
      this.summary = this.details?.querySelector('summary');
      if (!this.details || !this.summary) return;

      this.controller = new AbortController();
      this.media = window.matchMedia(query);
      this.inside = false;
      this.openedByHover = false;
      this.blockedUntilLeave = false;
      const signal = this.controller.signal;

      menu.addEventListener('pointerenter', (event) => this.enter(event), { signal });
      menu.addEventListener('pointerleave', (event) => this.leave(event), { signal });
      this.summary.addEventListener('click', () => {
        // Clicking or pressing Enter/Space keeps the native summary toggle.
        this.clearTimer();
        this.openedByHover = false;
      }, { signal });
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        if (!this.details.open) this.openedByHover = false;
      }, { signal });
      document.addEventListener('keyup', (event) => {
        if ((event.code !== 'Escape' && event.key !== 'Escape') || !this.openedByHover) return;
        this.blockedUntilLeave = this.inside;
        this.closeHover();
      }, { signal });
      this.media.addEventListener('change', () => {
        if (this.media.matches) return;
        this.inside = false;
        this.blockedUntilLeave = false;
        this.closeHover();
      }, { signal });
      menu.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.destroy(), { signal, once: true });
    }

    enter(event) {
      if (event.pointerType !== 'mouse' || !this.media.matches) return;
      this.inside = true;
      this.clearTimer();
      if (this.blockedUntilLeave || this.details.open) return;
      this.openedByHover = true;
      this.details.open = true;
      this.summary.setAttribute('aria-expanded', 'true');
    }

    leave(event) {
      if (event.pointerType !== 'mouse') return;
      this.inside = false;
      this.blockedUntilLeave = false;
      this.clearTimer();
      if (!this.openedByHover) return;
      this.timer = setTimeout(() => {
        this.timer = null;
        if (!this.inside && !this.menu.contains(document.activeElement)) this.closeHover();
      }, 180);
    }

    closeHover() {
      this.clearTimer();
      if (!this.openedByHover) return;
      this.openedByHover = false;
      if (this.details.open) this.menu.close();
      this.summary.setAttribute('aria-expanded', String(this.details.open));
    }

    clearTimer() {
      if (this.timer != null) clearTimeout(this.timer);
      this.timer = null;
    }

    destroy() {
      this.closeHover();
      this.controller?.abort();
      controllers.delete(this.menu);
    }
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-sitone-collection-hover], [data-sitone-menu-hover]').forEach((menu) => {
      if (typeof menu.close !== 'function') return;
      if (!controllers.has(menu)) controllers.set(menu, new HeaderHover(menu));
    });
  }

  // This file is a module, so duplicate theme-editor script tags execute once.
  customElements.whenDefined('header-menu').then(() => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
